/**
 * ショップ用カテゴリ一覧
 */

export default {
  /**
   * カテゴリ全取得
   * @returns {Array} カテゴリ一覧
   */
  getAll: function () {
    return this.CATEGORY;
  },
  CATEGORY: [
    {
      catLrgCd: "115",
      catLrgNm: "ベネ通販",
      list: [
        {
          catMidCd: "201",
          catMidNm: "家電・カメラ・AV機器",
          list: [
            {
              catSmlCd: "301",
              catSmNm: "調理家電"
            },
            {
              catSmlCd: "302",
              catSmNm: "電子レンジ・オーブン・トースター"
            },
            {
              catSmlCd: "303",
              catSmNm: "ホットプレート・グリル"
            },
            {
              catSmlCd: "304",
              catSmNm: "電気ケトル・コーヒーメーカー"
            },
            {
              catSmlCd: "305",
              catSmNm: "炊飯器"
            },
            {
              catSmlCd: "306",
              catSmNm: "冷蔵庫・冷凍庫"
            },
            {
              catSmlCd: "307",
              catSmNm: "空気清浄器・加除湿器"
            },
            {
              catSmlCd: "308",
              catSmNm: "季節家電"
            },
            {
              catSmlCd: "309",
              catSmNm: "掃除機・クリーナー"
            },
            {
              catSmlCd: "310",
              catSmNm: "照明器具"
            },
            {
              catSmlCd: "311",
              catSmNm: "洗濯機・乾燥機"
            },
            {
              catSmlCd: "312",
              catSmNm: "アイロン"
            },
            {
              catSmlCd: "313",
              catSmNm: "デジタルカメラ・ビデオカメラ"
            },
            {
              catSmlCd: "314",
              catSmNm: "タブレット・モバイルアクセサリー"
            },
            {
              catSmlCd: "315",
              catSmNm: "テレビ・チューナー"
            },
            {
              catSmlCd: "316",
              catSmNm: "ブルーレイ・DVDレコーダー"
            },
            {
              catSmlCd: "317",
              catSmNm: "オーディオ"
            },
            {
              catSmlCd: "318",
              catSmNm: "イヤホン・ヘッドホン"
            },
            {
              catSmlCd: "319",
              catSmNm: "マッサージ"
            },
            {
              catSmlCd: "320",
              catSmNm: "電動歯ブラシ"
            },
            {
              catSmlCd: "321",
              catSmNm: "体重計・体脂肪計"
            },
            {
              catSmlCd: "322",
              catSmNm: "血圧計・体温計"
            },
            {
              catSmlCd: "323",
              catSmNm: "活動量計・歩数計・万歩計"
            },
            {
              catSmlCd: "324",
              catSmNm: "家電・カメラ・AV機器(その他)"
            }
          ]
        },
        {
          catMidCd: "202",
          catMidNm: "パソコン・オフィス用品",
          list: [
            {
              catSmlCd: "301",
              catSmNm: "パソコン"
            },
            {
              catSmlCd: "302",
              catSmNm: "パソコン周辺機器"
            },
            {
              catSmlCd: "303",
              catSmNm: "オフィス向け家電"
            },
            {
              catSmlCd: "304",
              catSmNm: "電子辞書・電子文具"
            },
            {
              catSmlCd: "305",
              catSmNm: "筆記用具"
            },
            {
              catSmlCd: "306",
              catSmNm: "事務用品・文房具"
            }
          ]
        },
        {
          catMidCd: "203",
          catMidNm: "ビューティー&コスメ",
          list: [
            {
              catSmlCd: "301",
              catSmNm: "コスメ"
            },
            {
              catSmlCd: "302",
              catSmNm: "スキンケア"
            },
            {
              catSmlCd: "303",
              catSmNm: "ボディケア"
            },
            {
              catSmlCd: "304",
              catSmNm: "ヘアケア"
            },
            {
              catSmlCd: "305",
              catSmNm: "美顔器・美容機器"
            },
            {
              catSmlCd: "306",
              catSmNm: "美容器具"
            },
            {
              catSmlCd: "307",
              catSmNm: "ドライヤー・ヘアアイロン"
            },
            {
              catSmlCd: "308",
              catSmNm: "レディースシェーバー・脱毛器"
            },
            {
              catSmlCd: "309",
              catSmNm: "メンズシェーバー"
            },
            {
              catSmlCd: "310",
              catSmNm: "香水・フレグランス"
            },
            {
              catSmlCd: "311",
              catSmNm: "ビューティー&コスメ(その他)"
            }
          ]
        },
        {
          catMidCd: "204",
          catMidNm: "食品・飲料・お酒",
          list: [
            {
              catSmlCd: "301",
              catSmNm: "肉・ハム"
            },
            {
              catSmlCd: "302",
              catSmNm: "海産物"
            },
            {
              catSmlCd: "303",
              catSmNm: "米"
            },
            {
              catSmlCd: "304",
              catSmNm: "麺類"
            },
            {
              catSmlCd: "305",
              catSmNm: "惣菜"
            },
            {
              catSmlCd: "306",
              catSmNm: "野菜・果物"
            },
            {
              catSmlCd: "307",
              catSmNm: "スイーツ・お菓子"
            },
            {
              catSmlCd: "308",
              catSmNm: "健康食品・サプリメント"
            },
            {
              catSmlCd: "309",
              catSmNm: "アイス"
            },
            {
              catSmlCd: "310",
              catSmNm: "調味料・オイル"
            },
            {
              catSmlCd: "311",
              catSmNm: "ジャム・蜂蜜"
            },
            {
              catSmlCd: "312",
              catSmNm: "水・お茶・コーヒー"
            },
            {
              catSmlCd: "313",
              catSmNm: "ソフトドリンク"
            },
            {
              catSmlCd: "314",
              catSmNm: "お酒"
            }
          ]
        },
        {
          catMidCd: "205",
          catMidNm: "キッチン用品",
          list: [
            {
              catSmlCd: "301",
              catSmNm: "食器"
            },
            {
              catSmlCd: "302",
              catSmNm: "グラス・カップ・タンブラー"
            },
            {
              catSmlCd: "303",
              catSmNm: "弁当箱・マグボトル"
            },
            {
              catSmlCd: "304",
              catSmNm: "鍋・フライパン"
            },
            {
              catSmlCd: "305",
              catSmNm: "包丁・調理器具"
            },
            {
              catSmlCd: "306",
              catSmNm: "キッチン用品(その他)"
            }
          ]
        },
        {
          catMidCd: "206",
          catMidNm: "インテリア・寝具",
          list: [
            {
              catSmlCd: "301",
              catSmNm: "家具"
            },
            {
              catSmlCd: "302",
              catSmNm: "収納用品"
            },
            {
              catSmlCd: "303",
              catSmNm: "ラグ・カーペット"
            },
            {
              catSmlCd: "304",
              catSmNm: "クッション"
            },
            {
              catSmlCd: "305",
              catSmNm: "布団・シーツ"
            },
            {
              catSmlCd: "306",
              catSmNm: "マットレス"
            },
            {
              catSmlCd: "307",
              catSmNm: "枕"
            },
            {
              catSmlCd: "308",
              catSmNm: "置き・掛け時計"
            },
            {
              catSmlCd: "309",
              catSmNm: "インテリア用品(その他)"
            }
          ]
        },
        {
          catMidCd: "207",
          catMidNm: "ファッション",
          list: [
            {
              catSmlCd: "301",
              catSmNm: "バッグ"
            },
            {
              catSmlCd: "302",
              catSmNm: "財布・キーケース"
            },
            {
              catSmlCd: "303",
              catSmNm: "腕時計"
            },
            {
              catSmlCd: "304",
              catSmNm: "アクセサリー・ジュエリー"
            },
            {
              catSmlCd: "305",
              catSmNm: "ウェア"
            },
            {
              catSmlCd: "306",
              catSmNm: "シューズ・スニーカー"
            },
            {
              catSmlCd: "307",
              catSmNm: "ファッション小物(その他)"
            }
          ]
        },
        {
          catMidCd: "208",
          catMidNm: "日用雑貨・ペット・カタログギフト",
          list: [
            {
              catSmlCd: "301",
              catSmNm: "タオル"
            },
            {
              catSmlCd: "302",
              catSmNm: "バス・トイレ用品"
            },
            {
              catSmlCd: "303",
              catSmNm: "アロマグッズ"
            },
            {
              catSmlCd: "304",
              catSmNm: "レイングッズ"
            },
            {
              catSmlCd: "305",
              catSmNm: "ヘルスケア用品"
            },
            {
              catSmlCd: "306",
              catSmNm: "キャリーバッグ・トラベル用品"
            },
            {
              catSmlCd: "307",
              catSmNm: "防災グッズ"
            },
            {
              catSmlCd: "308",
              catSmNm: "ペット用品"
            },
            {
              catSmlCd: "309",
              catSmNm: "日用品・生活雑貨( その他)"
            },
            {
              catSmlCd: "310",
              catSmNm: "ギフト(その他)"
            }
          ]
        },
        {
          catMidCd: "209",
          catMidNm: "アウトドア・スポーツ",
          list: [
            {
              catSmlCd: "301",
              catSmNm: "ゴルフ"
            },
            {
              catSmlCd: "302",
              catSmNm: "アウトドア用品"
            },
            {
              catSmlCd: "303",
              catSmNm: "スポーツウェア"
            },
            {
              catSmlCd: "304",
              catSmNm: "スポーツシューズ"
            },
            {
              catSmlCd: "305",
              catSmNm: "スポーツアクセサリ"
            },
            {
              catSmlCd: "306",
              catSmNm: "自転車"
            },
            {
              catSmlCd: "307",
              catSmNm: "アウトドア・スポーツ(その他)"
            }
          ]
        },
        {
          catMidCd: "210",
          catMidNm: "ベビー＆キッズ用品・ホビー・ゲーム",
          list: [
            {
              catSmlCd: "301",
              catSmNm: "ベビー用品"
            },
            {
              catSmlCd: "302",
              catSmNm: "キッズ用品"
            },
            {
              catSmlCd: "303",
              catSmNm: "玩具(ベビー・キッズ向け)"
            },
            {
              catSmlCd: "304",
              catSmNm: "ゲーム機"
            },
            {
              catSmlCd: "305",
              catSmNm: "ゲームソフト"
            },
            {
              catSmlCd: "306",
              catSmNm: "日曜大工用品"
            },
            {
              catSmlCd: "307",
              catSmNm: "ガーデニング"
            },
            {
              catSmlCd: "308",
              catSmNm: "玩具・楽器(その他)"
            }
          ]
        }
      ]
    }
  ]
};
